import {Object} from 'core-js';
//import ClientDetail_Dummy from '../../assets/json/ClientDetail.json'

const getDefaultState = () => {
    return {
        ApplicantId:'',
        FormDetails:{
            applicationStatus:'',
            ApplicationId : '',
            ApplicationFormId : '',
            Status : 'draft',
            PendingVerification : false
        },
        CustomerDetails:{
            CustomerName : '',
            CustomerId : '',
            IdType : '',
            NRIC : '',
            OldID : '',
            TelMobile : '',
            EmailAddress : '',
            StaffId : '',
            EPFNo : '',
            FundType : '',
            SophisticatedInvestor: false,
            Age : 0,
            DateOfBirth : ''
        },
        AgentDetails:{
            AgentName : '',
            AgentCodeUT : '',
            AgentCodePRS : '',
            AgentEmail : ''
        },
        Account : {
            AccountId : '',
            AccountType : 'EPF',
            AccountName : ''
        },
        Holdings:[],
        NonEPFHoldings:[],
        FundDetails:[],
        BankAccount:[],
        Transaction: {
            tempBalance:'',
            Investment:[],
            Redemption:[],
            Switching:[],
            TotalCart : 0,
            TotalInvestment : 0,
            TotalRedemption : 0,
            TotalSwitching: 0,
            TotalInvestmentToPay : 0,
            FundSwitchOut :''
        },
        BasisRecommendation : '',
        Payment : [],
        PaymentDetails : {   
            TotalPaidAmount : 0,
            TotalPaymentBalance : 0,
            FPXPayment : false,
            FPXPaymentAmount : 0,
            FPXOrderNo : '',
            FPXOrderNoEncrypt : '',
            FPXSuccessful : true
        },
        SAT:{
            IsExpired : false,
            Score : 0,
            Category : '',
            Group : '',
            RiskProfile : '',
            ReferenceId : '',
            InvestmentObjective : {
                value:'',
                label:'',
                score : 0
            },
            InvestmentObjectiveScore : 0,
            InvestmentPeriod : {
                value:'',
                label:'',
                score : 0
            },
            InvestmentPeriodScore : 0,
            EstimatedNetWorth : {
                value:'',
                label:'',
                score : 0
            },
            EstimatedNetWorthScore : 0,
            EstimatedLiability : {
                value:'',
                label:'',
                score : 0
            },
            EstimatedLiabilityScore : 0,
            AnnualisedGain : {
                value:'',
                label:'',
                score : 0
            },
            AnnualisedGainScore : 0,
            Age : {
                value:'',
                label:'',
                score : 0
            },
            AgeScore : 0,
            AnnualIncome : {
                value:'',
                label:'',
                score : 0
            },
            AnnualIncomeScore : 0,
            RiskTolerance : {
                value:'',
                label:'',
                score : 0
            },
            RiskToleranceScore : 0,
            Bonds : '<1 year',
            BondsScore : 0,
            Derivatives : '<1 year',
            DerivativesScore : 0,
            Equities : '<1 year',
            EquitiesScore : 0,
            UTF : '<1 year',
            UTFScore : 0,
            FundCategory : [],
        },
        RequestEditDetails : {
            Remarks : ''
        }
    }
}

const state = getDefaultState()

//getters
const getters = {
    cartCount: state => {
        var inv = (state.Transaction.Investment.length != 'undefined') ? state.Transaction.Investment.length : 0;
        var red = (state.Transaction.Redemption.length != 'undefined') ? state.Transaction.Redemption.length : 0;
        var sw = (state.Transaction.Switching.length != 'undefined') ? state.Transaction.Switching.length : 0;
        return (inv + red + sw)
    },
    isInvestment: state => {
        var isInv = (state.Transaction.Investment.length != 'undefined') ? true : false;
            return  isInv          
    },
    isRedemption: state => {
        var isRD = (state.Transaction.Redemption.length != 'undefined') ? true : false;
            return  isRD          
    },
    isSwitching: state => {
        var isSW = (state.Transaction.Switching.length != 'undefined') ? true : false;
            return  isSW          
    }
}

//actions
const actions = {
    // SAT Settings
    GetScore({state,rootState}){
        var Bonds = rootState.Lookup.SATQLookup.Bonds.find(x => x.value === state.SAT.Bonds)
        state.SAT.BondsScore = Bonds.score
        var Derivatives = rootState.Lookup.SATQLookup.Derivatives.find(x => x.value === state.SAT.Derivatives)
        state.SAT.DerivativesScore = Derivatives.score
        var Equities = rootState.Lookup.SATQLookup.Equities.find(x => x.value === state.SAT.Equities)
        state.SAT.EquitiesScore = Equities.score
        var UTF = rootState.Lookup.SATQLookup.UTF.find(x => x.value === state.SAT.UTF)
        state.SAT.UTFScore = UTF.score
    },
    // Bank Account Settings
    Update_BankAccount({state}, Obj){
        state.index = state.BankAccount.findIndex(x => x.Id === Value.Id)
        var index = state.index;
        state.BankAccount[index].AccountNo = Obj.AccountNo;
        state.BankAccount[index].AccountName = Obj.AccountName;
        state.BankAccount[index].JointHolderName = Obj.JointHolderName;
        state.BankAccount[index].BankName = Obj.BankName;
        state.BankAccount[index].BankCode = Obj.BankCode;
        state.BankAccount[index].Currency = Obj.Currency;
        state.BankAccount[index].BankAccountAttachment = Obj.BankAccountAttachment;
        state.BankAccount[index].isDefault = Obj.isDefault;
        state.BankAccount[index].IsJointAccount = Obj.IsJointAccount
    },
    // Bank Account Settings
    Update_Investment({state}, Object){
        state.index = state.Transaction.Investment.findIndex(x => x.Id === Value.Id)
        var index = state.index;
        state.Transaction.Investment[index].Id = Object.Id;
        state.Transaction.Investment[index].Scheme = Object.Scheme;
        state.Transaction.Investment[index].Plan = Object.Plan;
        state.Transaction.Investment[index].FundCurrency = Object.FundCurrency;
        state.Transaction.Investment[index].IndividualContribution = Object.IndividualContribution;
        state.Transaction.Investment[index].DistributionInstruction = Object.DistributionInstruction;
        state.Transaction.Investment[index].SalesCharge = Object.SalesCharge;
        state.Transaction.Investment[index].DefaultOption = Object.DefaultOption;
        state.Transaction.Investment[index].ModeOfFrequency = Object.ModeOfFrequency;
        state.Transaction.Investment[index].SmartSave = Object.SmartSave;
        state.Transaction.Investment[index].SmartSaveStartDate = Object.SmartSaveStartDate;
        state.Transaction.Investment[index].SmartSaveEndDate = Object.SmartSaveEndDate;
        state.Transaction.Investment[index].Amount = Object.Amount;
        state.Transaction.Investment[index].TypeOfProduct = Object.TypeOfProduct;
    },
    Update_Redemption({state}, Object){
        state.index = state.Transaction.Redemption.findIndex(x => x.Id === Value.Id)
        var index = state.index;
        state.Transaction.Redemption[index].Id = Object.Id;
        state.Transaction.Redemption[index].Scheme = Object.Scheme;
        state.Transaction.Redemption[index].Plan = Object.Plan;
        state.Transaction.Redemption[index].FundCurrency = Object.FundCurrency;
        state.Transaction.Redemption[index].AmountOrUnit = Object.AmountOrUnit;
        state.Transaction.Redemption[index].Amount = Object.Amount;
        state.Transaction.Redemption[index].Units = Object.Units
        state.Transaction.Redemption[index].PaymentInstruction = Object.PaymentInstruction;
        state.Transaction.Redemption[index].CollectionMethod = Object.CollectionMethod;
        state.Transaction.Redemption[index].TypeOfProduct = Object.TypeOfProduct;
        state.Transaction.Redemption[index].ExitFees = Object.ExitFees;
        state.Transaction.Redemption[index].EmployerCode = Object.EmployerCode;
        state.Transaction.Redemption[index].RedeemAll = Object.RedeemAll;
    },
    Update_Switching({state}, Object){
        state.index = state.Transaction.Switching.findIndex(x => x.Id === Value.Id)
        var index = state.index;
        state.Transaction.Switching[index].Id = Object.Id;
        state.Transaction.Switching[index].FromScheme = Object.FromScheme;
        state.Transaction.Switching[index].ToScheme = Object.ToScheme;
        state.Transaction.Switching[index].Plan = Object.Plan;
        state.Transaction.Switching[index].UnitsOrPercentage = Object.UnitsOrPercentage;
        state.Transaction.Switching[index].Percentage = Object.Percentage;
        state.Transaction.Switching[index].Units = Object.Units;
        state.Transaction.Switching[index].FundCurrency = Object.FundCurrency;
        state.Transaction.Switching[index].SalesCharge = Object.SalesCharge;
        state.Transaction.Switching[index].TypeOfProduct = Object.TypeOfProduct
    },
    // Investment Settings 
    GetTotalInvestment({state}){
        var total = 0;
        var topay = 0;
        var InvestmentLength = state.Transaction.Investment.length
        for(var i=0;i<InvestmentLength;i++){
            total = total + parseInt(state.Transaction.Investment[i].Amount);
            if(state.Transaction.Investment[i].Plan!=='EPF'){
                topay = topay + parseInt(state.Transaction.Investment[i].Amount);
            }
        }
        state.Transaction.TotalInvestment = total;
        state.Transaction.TotalInvestmentToPay = topay;
    },
    GetTotalPaidAmount({state, dispatch}){
        var total = 0;
        for(var i=0;i<state.Payment.length;i++){
            total =  total + parseInt(state.Payment[i].PaymentAmount);
        }
        dispatch('GetTotalInvestment');
        state.PaymentDetails.TotalPaidAmount = total;
        state.PaymentDetails.TotalPaymentBalance = parseInt(state.Transaction.TotalInvestmentToPay) - parseInt(state.PaymentDetails.TotalPaidAmount);
        //console.log(state.PaymentDetails.TotalPaidAmount)
    },
    GetTotalRedeemAmount({state}){
        var total = 0;
        var RedemptionLength = state.Transaction.Redemption.length
        for(var i=0;i<RedemptionLength;i++){
            total = total + parseInt(state.Transaction.Redemption[i].Amount);
        }
        state.Transaction.TotalRedemption = total;
    },
    ClearClientDetails({ commit }) {
        
        commit('ResetState_ClientDetails');
    },
    InsertInvestmentCart({state, dispatch}) {

    },
    DeletePayment({ state }, Id){
        state.index = state.Payment.findIndex(x => x.Id === Id)
        var index = state.index;
        state.Payment.splice(index, 1)
    },
    Delete_Investment({state}, Id){
        state.index = state.Transaction.Investment.findIndex(x => x.Id === Id)
        var index = state.index;
        state.Transaction.Investment.splice(index, 1)
    },
    Delete_Redemption({state}, Id){
        state.index = state.Transaction.Redemption.findIndex(x => x.Id === Id)
        var index = state.index;
        state.Transaction.Redemption.splice(index, 1)
    },
    Delete_Switching({state}, Id){
        state.index = state.Transaction.Switching.findIndex(x => x.Id === Id)
        var index = state.index;
        state.Transaction.Switching.splice(index, 1)
    },
    async UpdateFPXDetailsInPayment({ state }, FPXDetails){
        for(var i=0;i<state.Payment.length;i++){
            if(state.Payment[i].TypeOfPayment==='MCMBB'){
                state.Payment[i].FPXOrderNo = FPXDetails.OrderNo
                state.Payment[i].FPXTrxId = FPXDetails.FPXTxnID
            }
        }
        return true
    }
}

//mutations
const mutations = {
    ResetState_ClientDetails(state) {
        Object.assign(state, getDefaultState());
    },
    dynamicSort(property) {
        var sortOrder = 1;

        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }

        return function (a, b) {
            if (sortOrder == -1) {
                return b[property].localeCompare(a[property]);
            } else {
                return a[property].localeCompare(b[property]);
            }
        }
    },
    GetInvestmentDetail(state, jsonObj) {
        state.FundDetails = [];

        jsonObj.Funds.sort(function (a, b) {
            //return b.TypeOFund < a.TypeOFund
            return ('' + a.TypeOFund).localeCompare(b.TypeOFund)
        })
        for (var i = 0; i < jsonObj.Funds.length; i++) {
            state.FundDetails.push({
                TypeOFund: jsonObj.Funds[i].TypeOFund,
                MarketValue: jsonObj.Funds[i].MarketValue,
                Plan: jsonObj.Funds[i].Plan
            })
        }
        // state.FundDetails.sort();
    },
    AddToInvestmentCart (state, transactionId, jsonObj) {
        const record = state.Transaction.Investment.find(Investment => Investment.id === transactionId)
        if (!record) {
            state.Transaction.Investment.push({
                Id: jsonObj.Id,
                FundId: jsonObj.FundId,
                FundCurrency: jsonObj.FundCurrency,
                Plan: jsonObj.Plan,
                SmartSave: jsonObj.SmartSave,
                SmartSaveStartDate: jsonObj.SmartSaveStartDate,
                SmartSaveEndDate: jsonObj.SmartSaveEndDate,
                ModeOfFrequency: jsonObj.ModeOfFrequency,
                TypeOfProduct: jsonObj.TypeOfProduct,
                Amount: jsonObj.Amount,
                IndividualContribution: jsonObj.IndividualContribution,
                SalesCharge: jsonObj.SalesCharge,
                DistributionInstruction: jsonObj.DistributionInstruction,
                DefaultOption: jsonObj.DefaultOption
            })
        }
    },

    RemoveFromInvestmentCart (state, item) {
        const index = state.Transaction.Investment.findIndex(Investment => Investment.id === item.id)
        state.Transaction.Investment.splice(index, 1)
    },

    AddToRedemptionCart (state, transactionId, jsonObj) {
        const record = state.Transaction.Investment.find(Investment => Investment.id === transactionId)
        if (!record) {
            state.Transaction.Investment.push({
                Id: jsonObj.Id,
                FundId: jsonObj.FundId,
                FundCurrency: jsonObj.FundCurrency,
                Plan: jsonObj.Plan,
                AmountOrUnit: jsonObj.AmountOrUnit,
                Amount: jsonObj.Amount,
                Units: jsonObj.Units,
                PaymentInstruction: jsonObj.PaymentInstruction,
                TypeOfProduct: jsonObj.TypeOfProduct,
            })
        }
    },

    RemoveFromRedemptionCart (state, item) {
        const index = state.Transaction.Redemption.findIndex(Redemption => Redemption.id === item.id)
        state.Transaction.Redemption.splice(index, 1)
    },

    AddToSwtichingCart (state, transactionId, jsonObj) {
        const record = state.Transaction.Switching.find(Switching => Switching.id === transactionId)
        if (!record) {
            state.Transaction.Investment.push({
                Id: jsonObj.Id,
                FromFundID: jsonObj.FromFundID,
                ToFundID: jsonObj.ToFundID,
                UnitsOrPercentage: jsonObj.UnitsOrPercentage,
                Percentage: jsonObj.Percentage,                
                Units: jsonObj.Units,
                Plan: jsonObj.Plan,
                FundCurrency: jsonObj.FundCurrency,
                TypeOfProduct: jsonObj.TypeOfProduct,
                SalesCharge: jsonObj.SalesCharge
            })
        }
    },

    RemoveFromSwitchingCart (state, item) {
        const index = state.Transaction.Switching.findIndex(Switching => Switching.id === item.id)
        state.Transaction.Switching.splice(index, 1)
    },


}

export default {
    state,
    getters,
    actions,
    mutations
}
